import React from 'react'
import './Header.css';
import SearchIcon from '@material-ui/icons/Search';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import {Link} from "react-router-dom";
import {useStateValue} from "./StateProvider";
import {auth} from "./firebase";
function Header() {
    const handleAuthentication=()=>{
        if(user){
            auth.signOut();
        }
    }
     const [{basket,user}, dispatch]=useStateValue();
    return (
        <div className="header">
            <Link to="/">
                    <img className="header_logo" src="https://pngimg.com/uploads/amazon/amazon_PNG11.png" alt=""/>

            </Link>
            
             <div className="header_search">
                 <input
                 className="header_searchInput"
                 type="text" />
                 <SearchIcon className="header_searchIcon" />
             </div>
             <div className="header_nav">
                 <Link to={!user && "/login"}>
                 <div onClick={handleAuthentication} className='header_option'>
                     <span className= 'header_optionlineone'>Hello Guest</span>
                     <span className= 'header_optionlinetwo'>{user ? 'Sign Out': 'Sign In'}</span>
                 </div>                     

                 </Link>
                
                 <div className="header_option">
                      <span className= 'header_optionlineone'>Returns</span>
                     <span className= 'header_optionlinetwo'>& Orders </span>
                 </div>
                 <div className="header_option">
                      <span className= 'header_optionlineone'>Your</span>
                     <span className= 'header_optionlinetwo'>Prime </span>
                 </div>
                 <Link to="/checkout">
                 <div className="header_openbasket">
                      <AddShoppingCartIcon />
                      <span className= 'header_basketCount'>{basket.length}</span>
                 </div>
                 </Link>
                  
             </div>
        </div>
         
    );
}

export default Header
